import { 
  //State, 
  ViewState 
} from "../../Views/GLU/viewReducer";

// Campaigns list
export const GLU_GET_CAMPAIGNS_LIST_REQUEST = "GLU_GET_CAMPAIGNS_LIST_REQUEST";
export const GLU_GET_CAMPAIGNS_LIST_SUCCESS = "GLU_GET_CAMPAIGNS_LIST_SUCCESS";
export const GLU_GET_CAMPAIGNS_LIST_FAILURE = "GLU_GET_CAMPAIGNS_LIST_FAILURE";

export const getCampaignsListRequest = () => {
  return { type: GLU_GET_CAMPAIGNS_LIST_REQUEST };
};

export const getCampaignsListSuccess = () => {
  return { type: GLU_GET_CAMPAIGNS_LIST_SUCCESS };
};

export const getCampaignsListFailure = () => {
  return { type: GLU_GET_CAMPAIGNS_LIST_FAILURE };
};

// Campaigns status
export const GLU_GET_CAMPAIGN_STATUS_REQUEST = "GLU_GET_CAMPAIGN_STATUS_REQUEST";
export const GLU_GET_CAMPAIGN_STATUS_SUCCESS = "GLU_GET_CAMPAIGN_STATUS_SUCCESS";
export const GLU_GET_CAMPAIGN_STATUS_FAILURE = "GLU_GET_CAMPAIGN_STATUS_FAILURE";

export const getCampaignStatusRequest = (id: String) => {
  return { type: GLU_GET_CAMPAIGN_STATUS_REQUEST, payload: id };
};

export const getCampaignStatusSuccess = () => {
  return { type: GLU_GET_CAMPAIGN_STATUS_SUCCESS };
};

export const getCampaignStatusFailure = () => {
  return { type: GLU_GET_CAMPAIGN_STATUS_FAILURE };
};

// Create new campaign
export const GLU_CREATE_CAMPAIGN_REQUEST = "GLU_CREATE_CAMPAIGN_REQUEST";
export const GLU_CREATE_CAMPAIGN_SUCCESS = "GLU_CREATE_CAMPAIGN_SUCCESS";
export const GLU_CREATE_CAMPAIGN_FAILURE = "GLU_CREATE_CAMPAIGN_FAILURE";

export const createCampaignRequest = (body: any) => {
  return { type: GLU_CREATE_CAMPAIGN_REQUEST, payload: body };
};

export const createCampaignSuccess = () => {
  return { type: GLU_CREATE_CAMPAIGN_SUCCESS };
};

export const createCampaignFailure = () => {
  return { type: GLU_CREATE_CAMPAIGN_FAILURE };
};

// Create new campaign
export const GLU_GET_CAMPAIGN_REQUEST = "GLU_GET_CAMPAIGN_REQUEST";
export const GLU_GET_CAMPAIGN_SUCCESS = "GLU_GET_CAMPAIGN_SUCCESS";
export const GLU_GET_CAMPAIGN_FAILURE = "GLU_GET_CAMPAIGN_FAILURE";

export const getCampaignRequest = (id: String) => {
  return { type: GLU_GET_CAMPAIGN_REQUEST, payload: id };
};

export const getCampaignSuccess = () => {
  return { type: GLU_GET_CAMPAIGN_SUCCESS };
};

export const getCampaignFailure = () => {
  return { type: GLU_GET_CAMPAIGN_FAILURE };
};


// Switch view
export const GLU_SWITCH_VIEW = "GLU_SWITCH_VIEW";

export const gluSwitchView = (view: ViewState) => {
  return { type: GLU_SWITCH_VIEW, payload: view };
};
